const constant = {
  // LocalStorage Keys
  authToken: "auth-token", // Token key for authentication
  currentUser: "current-user", // User details
  userRoleKey: "user-role", // User role key
  appSettings: "app-settings", // Application settings

  // // API URLs
  // api: "http://localhost:8010/api/",
  // url: "http://localhost:8010/",

  // Uncomment the relevant API URLs for production
  api: "https://api2.lignacommerce.com/api/",
  url: "https://api2.lignacommerce.com/",

  // api: "http://api10.peascom.ma/api/",
  // url: "http://api10.peascom.ma/",

  // api: "http://api11.peascom.ma/api/",
  // url: "http://api11.peascom.ma/",

  SupportApi: "https://api.peascom.ma/api/",
  SupportUrl: "https://api.peascom.ma/",

  // LocalChat AI (local LLM server)
  // localChatApi: "http://localhost:7860",
  localChatApi: "https://api.groq.com/openai",
};

export default constant;
